import { get } from "svelte/store"
import { location, newNotification } from "../../store"

export function checkPassword(password: string): string | null {
    if (password.length < 7) return "Das Passwort muss mindestens 7 Zeichen lang sein."

    const hasAlphabetic = /[a-zA-Z]/.test(password)
    if (!hasAlphabetic) return "Das Passwort muss mindestens einen alphabetischen Buchstaben enthalten."

    const hasNumeric = /[0-9]/.test(password)
    if (!hasNumeric) return "Das Passwort muss mindestens eine Zahl enthalten."

    return null
}

export function validateInput(input: string): string | null {
    return input?.length > 0 ? null : "Dieses Feld ist erforderlich."
}

export function validateDataProtection(checked: boolean): string | null {
    return checked ? null : "Bitte akzeptiere die Datenschutzbestimmungen."
}

export function isValidLangOrLatCoordinate(coordinate: string): string | null {
    const regex = /^-?([1-8]?\d(?:\.\d{1,18})?|90(?:\.0{1,18})?)$/
    return regex.test(coordinate) ? null : "Ungültige Koordinate"
}

export function onChange(e: Event, element = e.currentTarget as HTMLInputElement) {
    const el = element
    el.classList.remove("error")

    const parent = el.parentElement
    const errorNode = parent?.querySelector(".error-message")
    if (errorNode) {
        parent?.removeChild(errorNode)
    }
}

export function removeAllErrors(form: HTMLFormElement) {
    const errorNodes = form.querySelectorAll(".error-message")
    errorNodes.forEach((node) => node.remove())

    const errorInputs = form.querySelectorAll(".error")
    errorInputs.forEach((input) => input.classList.remove("error"))
}

export function appendErrorMessage(
    element: HTMLInputElement | HTMLDivElement,
    message: string,
    parentEl?: HTMLElement
) {
    const parent = parentEl || element.parentElement
    if (parent) {
        let existingErrorNode = parent.querySelector(".error-message")
        if (existingErrorNode) {
            existingErrorNode.textContent = message
        } else {
            const errorNode = document.createElement("div")
            errorNode.className = "error-message"
            errorNode.textContent = message
            parent.appendChild(errorNode)
        }
    }
}
export function getQueryParam(param: string) {
    return new URLSearchParams(get(location).search).get(param)
}
export function validateField(
    elementId: string,
    value: string | boolean,
    validator: (value: string | boolean) => string | null
): boolean {
    const element = document.getElementById(elementId) as HTMLInputElement

    const error = validator(value)
    if (error && element) {
        element.classList.add("error")
        appendErrorMessage(element, error)
        newNotification({ html: error, class: "error" })
        return false
    }
    return true
}
